/**
 * StickyHeader.js
 * Subheader component
 *
 * @class   Subheader
 * @author  Randy Lebeau
 * @author  Robert Sahm
 *
 */

import React from 'react/addons';
import ClassNames from 'classnames';
import Paper from 'components/paper/Paper';
import Events from 'utils/events';

const PureRenderMixin = React.addons.PureRenderMixin;

export default React.createClass({

	displayName: 'StickyHeader',

	mixins: [ PureRenderMixin ],

	propTypes: {
		width: React.PropTypes.string,
		height: React.PropTypes.string,
		offsetTop: React.PropTypes.number,
		status: React.PropTypes.string,
		overflow: React.PropTypes.bool
	},

	getDefaultProps() {
		return {
			offsetTop: 0,
			status: 'primary',
			overflow: false
		};
	},

	getInitialState() {
		return {
			active: true,
			title: this.props.children[0] ?this.props.children[0].props.title : this.props.children.props.title,
			tools: this.props.children[0] ? this.props.children[0].props.tools : this.props.children.props.tools,
			topPos: 0
		};
	},

	componentDidMount() {
		let target = this.props.width && this.props.height ? this.getDOMNode() : window;
		target.addEventListener('scroll', this._onScroll);
	},

	componentWillUnmount() {
		let target = this.props.width && this.props.height ? this.getDOMNode() : window;
		target.removeEventListener('scroll', this._onScroll);

	},

	render() {

		let fixed = this.props.width && this.props.height ? 'lui-sticky-header-absolute' : 'lui-sticky-header-fixed';

		let classes = ClassNames( `lui-is-${this.props.status}` ,{
			'lui-sticky-header-overflow' : this.props.width && this.props.height && !this.props.overflow
		});

		let headerStyles = {
			width: this.props.width && this.props.height ? this.props.width : '',
			top: this.state.topPos === 0 ? 'initial' : this.state.topPos - this.props.offsetTop
		};
		let styleHeight = { height: this.props.width && this.props.height ? this.props.height : 'auto' };

		return(

			<div id="lui-sticky-header" className={classes} style={styleHeight}>
				<div ref="header" style={headerStyles} className={fixed}>
					<Paper
						innerClassName="lui-sticky-header-paper"
						depth={ this.state.active ? 1 : 0 }
						healTop={true}
						healLeft={true}
						healRight={true}>
						<div className="lui-font-style-toolbar lui-sticky-header-content">
							<span>{this.state.title}</span>
							<span className="lui-sticky-header-tools">{this.state.tools}</span>
						</div>
					</Paper>
				</div>

				<div innerClassName="lui-sticky-header-paper">
					{this._generateChildren()}
				</div>
			</div>

		);
	},

	_generateChildren() {

		let index = 0;
		let children = React.Children.map(this.props.children, function(child) {
				if(!child) return;
				return React.addons.cloneWithProps(child, {
					ref: 'child-' + (index++)
				});
			});

		return children;

	},

	_onScroll(event) {

		let _this = this;
		let headerHeight = this.refs.header.getDOMNode().offsetHeight;

		// Loop through children
		let last_height = 0;
		let last_key = [];

		let should_be_shown = '';
		let should_be_shown_key = '';
		let shown_tracker = null;

		let headers_transitioning = false;
		let header_check_function = function(key, scrollTop, top, topPos) {

			// console.log('!', _this.refs[key].props.title, scrollTop, top, topPos);
			if (shown_tracker === null) {

				should_be_shown = _this.refs[key].props.title;
				should_be_shown_key = key;

			} else if ((shown_tracker < 0) && (top < 0)) {

				should_be_shown = _this.refs[key].props.title;
				should_be_shown_key = key;

			}

		};

		for(let key in this.refs) {

			switch(key) {
				case 'header':
					break;
				default:

					if(this.props.width && this.props.height) {

						let scrollTop = this.getDOMNode().scrollTop,
							child = this.refs[key].getPosition().element,
							childPosition = this.refs[key].getPosition(),
							top = this.props.offsetTop ? last_height - scrollTop - this.props.offsetTop : last_height - scrollTop,
							topPos = this.refs.header.getDOMNode().offsetTop - (top * -1) - headerHeight;

						header_check_function(key, scrollTop, top, topPos)
						shown_tracker = top;

						if(this.state.active && topPos > headerHeight * -1 && top < headerHeight) {
							headers_transitioning = true;
							this.setState({
								active: false,
								topPos: topPos,
							});
						}

						if(!this.state.active && top <= 0 && top > childPosition.height * -1) {
							headers_transitioning = true;
							this.setState({
								active: true,
								title: childPosition.title,
								tools: childPosition.tools,
								topPos: 0
							});
						}

						last_height += childPosition.height;


					} else {

						let scrollTop = window.pageYOffset,
							child = this.refs[key].getPosition().element,
							childPosition = this.refs[key].getPosition(),
							top = this.props.offsetTop ? last_height - scrollTop - this.props.offsetTop : last_height - scrollTop,
							topPos = this.refs.header.getDOMNode().offsetTop - (top * -1) - headerHeight;

						header_check_function(key, scrollTop, top, topPos)
						shown_tracker = top;

						if(this.state.active && topPos > headerHeight * -1 && top < headerHeight ) {
							headers_transitioning = true;
							this.setState({
								active: false,
								topPos: topPos,
								title: child.title
							});
						}

						if(!this.state.active && top <= 0 && top > childPosition.height * -1) {
							headers_transitioning = true;
							this.setState({
								active: true,
								title: childPosition.title,
								tools: childPosition.tools,
								topPos: 0
							});
						}

						last_height += child.height;
					}
			}

		}

		if (!headers_transitioning) {
			// console.log(event, headerHeight, 'should be shown', should_be_shown, should_be_shown_key);
			this.setState({
				active: true,
				title: this.refs[should_be_shown_key].getPosition().title,
				tools: this.refs[should_be_shown_key].getPosition().tools,
				topPos: 0
			});
		}

	}

});



/** WEBPACK FOOTER **
 ** ./src/components/sticky-header/StickyHeader.js
 **/